__turbopack_context__.v({
  "body": "FilterDrawer-module-scss-module__oWNOtq__body",
  "borderTop": "FilterDrawer-module-scss-module__oWNOtq__borderTop",
  "buttons": "FilterDrawer-module-scss-module__oWNOtq__buttons",
  "drawerButtonPrimary": "FilterDrawer-module-scss-module__oWNOtq__drawerButtonPrimary",
  "drawerButtonSecondary": "FilterDrawer-module-scss-module__oWNOtq__drawerButtonSecondary",
  "fieldCount": "FilterDrawer-module-scss-module__oWNOtq__fieldCount",
  "fieldDetails": "FilterDrawer-module-scss-module__oWNOtq__fieldDetails",
  "fieldSearch": "FilterDrawer-module-scss-module__oWNOtq__fieldSearch",
  "fieldSubtitle": "FilterDrawer-module-scss-module__oWNOtq__fieldSubtitle",
  "fieldSwitch": "FilterDrawer-module-scss-module__oWNOtq__fieldSwitch",
  "form": "FilterDrawer-module-scss-module__oWNOtq__form",
  "formRow": "FilterDrawer-module-scss-module__oWNOtq__formRow",
  "formRowField": "FilterDrawer-module-scss-module__oWNOtq__formRowField",
  "formRowIcon": "FilterDrawer-module-scss-module__oWNOtq__formRowIcon",
  "formRowPadded": "FilterDrawer-module-scss-module__oWNOtq__formRowPadded",
  "headerDetails": "FilterDrawer-module-scss-module__oWNOtq__headerDetails",
  "headerDisplay": "FilterDrawer-module-scss-module__oWNOtq__headerDisplay",
  "headerIcon": "FilterDrawer-module-scss-module__oWNOtq__headerIcon",
  "headerTitle": "FilterDrawer-module-scss-module__oWNOtq__headerTitle",
});
